import { notificationTypes } from '@/helpers/enums';
import store from '@/store';

export const notificationOptions = {
	icon: '/logo.png',
	dir: 'rtl',
	lang: 'ar-SA',
};

export const notificationPageRedirect = [
	{ type: notificationTypes.message, redirect: '/chat', routeName: 'chat' },
	{ type: notificationTypes.attendance, redirect: '/attendance', routeName: 'attendance' },
	{ type: notificationTypes.newMark, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.newMarks, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.schedule, redirect: '/schedule', routeName: 'schedule' },
	{ type: notificationTypes.newTest, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.testsSchedule, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.transport, redirect: '/', routeName: 'home' },
	{ type: notificationTypes.notes, redirect: '/behavior', routeName: 'behavior' },
];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyD1Myzf83wDf_x9JL_q8TaxCdqInaFLMB8',
		authDomain: 'alawal-school-app.firebaseapp.com',
		projectId: 'alawal-school-app',
		storageBucket: 'alawal-school-app.appspot.com',
		messagingSenderId: '1028760004122',
		appId: '1:1028760004122:web:da04c40f60e875963393a3'
	},
	publicKey: 'BLBZ7Gc8iBGH0YBH8NnnjgyTQA8vVcnlMxMCZ2ezc7nNuZ14MYXsSHZoDUP_KECMzCzl9l-CysgyJMGwxSoTzws',
};

export const onGetNotification = () => {
	store.dispatch('notification/fetchAll');
};
